export enum QRCodeType {
  BARCODE = "Barcode",
  QR_CODE = "QR Code",
}

export default QRCodeType;
